/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import './Footer.scss';
import packageJson from '../../../../../package.json';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <p>
        {t('ui.copyright')} |{' '}
        <a href="https://vaisala.com" target="_blank" rel="noreferrer">
          vaisala.com
        </a>
      </p>
      <p>
        {t('ui.version')} {packageJson?.version} {packageJson?.version.startsWith('0') ? 'Beta' : ''}
      </p>
    </div>
  );
};
export default Footer;
